export default (theme) => ({
  dataLine: {
    minWidth: 'calc(50% - 20px)',
    display: 'flex',
    minHeight: 60,
    flexDirection: 'column',
    marginBottom: 50,
    [theme.breakpoints.down('lg')]: {
      minWidth: 'initial',
      minHeight: 'initial',
      marginBottom: 25,
    },
  },
  title: {
    fontWeight: 'bold',
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  info: {
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
});
